import { inject, Injectable, NgZone } from "@angular/core";

@Injectable()
export class KeyboardService {
	private ngZone = inject(NgZone);

	private keysDown = new Set<number>();

	constructor() {
		this.ngZone.runOutsideAngular(() => {
			document.addEventListener("keydown", this.onKeyDown.bind(this));
			document.addEventListener("keyup", this.onKeyUp.bind(this));
		});
	}

	private onKeyDown(event: KeyboardEvent) {
		this.keysDown.add(event.keyCode);
	}

	private onKeyUp(event: KeyboardEvent) {
		this.keysDown.delete(event.keyCode);
	}

	isDown(key: number) {
		return this.keysDown.has(key);
	}
}
